import { isNumber } from 'angular';
export var AddToFavouritesButtonDirective = [
    '$rootScope',
    '$location',
    'lightbox',
    'favouritesService',
    function ($rootScope, $location, lightbox, favouritesService) {
        return {
            link: function ($scope, $element) {
                var checkIfActive = function () {
                    $scope.isActive = favouritesService.check($scope.targetUrl || $location.url());
                    $element.toggleClass('active', $scope.isActive);
                };
                var onFavouritesChangedWatcher;
                var onLocationChangedWatcher;
                if ($scope.showText !== true) {
                    $element.find('cg-icon').addClass("cg-icon-rounded cg-icon-rounded-size-" + $scope.roundSize);
                }
                if (isNumber($scope.size)) {
                    $element.find('cg-icon').addClass("cg-icon-size-" + $scope.size);
                }
                $element.on('click', function () {
                    lightbox.showPartial('compatibilityguide/ng-templates/feature/favourites/addtofavourites', {
                        group: $scope.group,
                        pageType: $scope.pageType,
                        showRemoveButton: $scope.isActive,
                        targetUrl: $scope.targetUrl,
                        thirdPartyDevices: $scope.thirdPartyDevices,
                    });
                });
                onFavouritesChangedWatcher = $rootScope.$on('favourites:changed', checkIfActive);
                onLocationChangedWatcher = $rootScope.$on('$locationChangeSuccess', checkIfActive);
                checkIfActive();
                $scope.$on('$destroy', function () {
                    $element.off('click');
                    onFavouritesChangedWatcher();
                    onLocationChangedWatcher();
                });
            },
            restrict: 'E',
            scope: {
                group: '<?',
                pageType: '@',
                showText: '<?',
                size: '<?',
                roundSize: '<?',
                targetUrl: '<?',
                thirdPartyDevices: '<',
            },
            templateUrl: 'compatibilityguide/ng-templates/feature/favourites/addtofavouritesbutton',
        };
    },
];
